import { useHistory } from 'react-router'
import { map } from 'lodash'
import { FieldArray, useFormikContext } from 'formik'
import { v4 as uuid } from 'uuid'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import MenusItem from 'components/RevenueCenters/Form/Menus/MenusItem'

import { getCurrentRevenueCenter } from 'store/RevenueCenters/selector'
import { getDisplayMenuName } from 'utils/revenueCenters'

const Menus = ({ showValidationErrors, setShowValidationErrors }) => {
  const { values } = useFormikContext()
  const { state: locationState } = useLocation()
  const history = useHistory()

  const { id } = useSelector((state) =>
    getCurrentRevenueCenter(state, locationState?.revenueCenterUuid)
  )

  const { menus } = values

  const onClickAddMenu = (arrayHelpers) => {
    setShowValidationErrors(false)

    const newUuid = uuid()

    arrayHelpers.push({
      name: '',
      displayName: '',
      uuid: newUuid,
      standId: id,
      configurationModelId: '',
      isNewMenu: true,
    })

    history.push({
      state: {
        ...history.location.state,
        menuUuid: newUuid,
        isNewMenu: true,
        modalType: 'menu',
      },
    })
  }

  return (
    <section>
      <h3 className="header-title">Menus</h3>
      <FieldArray
        name="menus"
        render={(arrayHelpers) => (
          <>
            {map(menus, (menu, index) => {
              const { name, displayName } = getDisplayMenuName(menu)

              return (
                <MenusItem
                  key={menu.uuid}
                  uuid={menu.uuid}
                  displayName={displayName}
                  merchantId={menu?.merchantId}
                  index={index}
                  name={name}
                  showValidationErrors={showValidationErrors}
                  setShowValidationErrors={setShowValidationErrors}
                />
              )
            })}

            <div className="content-wrapper -flags-wrapper">
              <button
                className="btn -outline -block"
                onClick={() => onClickAddMenu(arrayHelpers)}
                type="button"
                data-cy="add-menu-button"
              >
                Add a Menu
              </button>
            </div>
          </>
        )}
      />
    </section>
  )
}

export default Menus
